module.exports = __webpack_public_path__ + "static/media/truck-schedule-2.6d656b25.jpg";